(() => {
  if (window.__rpProductCardDelegationBound) return;
  window.__rpProductCardDelegationBound = true;

  const interactiveSelector = [
    'a',
    'button',
    '[role="button"]',
    'input',
    'select',
    'textarea',
    'product-form',
    '.quick-add',
    '.quantity-popover',
  ].join(', ');

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const card = target.closest('.product-card-wrapper .card[data-product-url]');
    if (!card || target.closest(interactiveSelector)) return;

    const url = card.getAttribute('data-product-url');
    if (url) window.location.assign(url);
  }, true);
})();
